const props = {
    /** Setting create params before sending event. */
    onCreate: {
        required: false,
        /** 
         * @param {import('@spa/types/bus').EventBusListenerParams<'contacts.create', import('@spa/types/bus').PackageEventBusEvents>} params
         * @returns {import('@spa/types/bus').EventBusListenerParams<'contacts.create', import('@spa/types/bus').PackageEventBusEvents>}
         */
        default: params => params
    },
    /** Setting edit params before sending event. */
    onEdit: {
        required: false,
        /** 
         * @param {import('@spa/types/bus').EventBusListenerParams<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>} params
         * @returns {import('@spa/types/bus').EventBusListenerParams<'contacts.edit', import('@spa/types/bus').PackageEventBusEvents>}
         */
        default: params => params
    }
}

const mixin = { props };

export { props as searchContactFormMixinProps };
export default mixin;